var $ = require('jquery');
require('slick');
var Swiper = require('swiper');
var MQ = require('mq');

require('lightslide.js');

var bloc_slide_change = require('./home-slide-change.js');

var previousWidth = $(window).width(); // Initialize previous width

// $(window).on('resize', function() {
// 	  var currentWidth = $(window).width(); // Get current window width

// 	  // Check if width has crossed the threshold (768px)
// 	  if ((previousWidth < 768 && currentWidth >= 768) || 
// 	      (previousWidth >= 768 && currentWidth < 768)) {
// 	    // Toggle refresh code for Slick slider
// 		$(el).find('[data-js="slideshow"]').each(function(i, el){
// 			$(el).find('[data-js="slideshow-items"]').slick('refresh');
// 		});
// 	  }

// 	  // Update previousWidth for next comparison
// 	  previousWidth = currentWidth;
// });

$(window).on('site:initPage', function(evt, el){
	$(el).find('[data-js="slideshow"]').each(function(i, el){
		// alert('x')

		$(el).addClass('display-not-first');

		var slick_options = {
			'prevArrow' : $(el).find('[data-js="slideshow-arrow"]').filter('.prev'),
			'nextArrow' : $(el).find('[data-js="slideshow-arrow"]').filter('.next'),
			autoplay: true,
			// arrows: false,
			fade: true,
			infinite: true,
			autoplaySpeed: 4000,
			// pauseOnHover: true,
			pauseOnFocus: true,
			speed: 600,
			slidesToShow: 1,
			// slidesToScroll: 3,
			swipeToSlide: true,
			mobileFirst: true,
			// variableWidth: true,
			// centerMode: true,
			// responsive: [
			//     {
			//       breakpoint: 8000,
			//       settings: 'unslick'
			//     },
			//     {
			//       breakpoint: 768,
			//       settings: {
			//         slidesToShow: 1,
			//         slidesToScroll: 1
			//       }
			//     }
			//     // You can unslick at a given breakpoint now by adding:
			//     // settings: "unslick"
			//     // instead of a settings object
			//   ]
			// asNavFor: '.imm__slide__titres__items, .imm__slide__txts__items'
			// appendDots: $(el).prev(),
			// appendDots: $(el).parent().find('[data-js="slickdots"]'),
			// dots: true,
			// dotsClass : 'slickslide__navs'
		};
		if ( $(el).closest('.home__services__slide--services').length ){
			slick_options.responsive = [{breakpoint:768, settings: 'unslick'}];
		}
		if ( $(el).attr('data-onlypho') == '1' ){
			slick_options.responsive = [{breakpoint:768, settings: 'unslick'}];
		}
		if ( $(el).find('.map').length > 0 ){
			slick_options.swipeToSlide = false;
		}
		$(el).find('[data-js="slideshow-items"]').on('init', function(event, slick){
			$(window).trigger('slides:init', [slick]);
		});

		var dataOptions = el.getAttribute('data-slick-options');
		if (dataOptions) {
		  try {
			  	const cleanOptions = dataOptions.replace(/'/g, '"');
			  	console.log('cleanOptions', cleanOptions);
		      const parsedOptions = JSON.parse(cleanOptions); // transformer les quotes simples en doubles si nécessaire
		      console.log('parsedOptions', parsedOptions);
		      slick_options = { ...slick_options, ...parsedOptions };
		  } catch (e) {
		      console.warn('Erreur dans data-slick-options:', e);
		  }
		}

		var $slider = $(el).find('[data-js="slideshow-items"]');

		$slider.slick(slick_options);
		// alert( $(el).find('.slideshow__item').length )
		if ( $(el).find('.slideshow__item').length < 2 ){
			$(el).find('.slideshow__navs').hide();
		}

		// On before slide change
		$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			console.log(slick);
			console.log(currentSlide);
			console.log(nextSlide);
			// $(el).find('.home__video__txts').removeClass('is-active')
				// .eq( nextSlide ).addClass('is-active')
			if ( $(slick.$slides[nextSlide]).find('.cahier__content__plans__slideshow__legende').length > 0 ){
				console.log('founded');
				var legende = $(slick.$slides[nextSlide]).find('.inner').html();
				console.log('legende', legende);
				var old = $('.cahier__content__plans__tag .inner').html(legende);
				// var n = old.clone();

			}
			$(window).trigger('slides:slickBeforeChange', [slick, currentSlide, nextSlide]);
		});

		$slider.on('init', function(event, slick){
			$(window).trigger('slides:init', [slick]);
		});

		// $(el).find('.home__video__txts').eq(0).addClass('is-active')
		
		// var options = $(el).attr('data-js-options');
		
		// if ( $(el).attr('data-js-options') == 'slick-with-navs' ) {
			var size = $(el).find('[data-js="slick-nav-item"]').size();
			// custom navs
			$(el).find('[data-js="slick-nav-item"]').click(function(){
				var index = $(this).index();
				console.log('index', index);
				if ( $(this).closest('.services__content').length == 0 || MQ(-767) ){
					$slider.slick('slickPause');
					$slider.slick('slickGoTo', index);
				}
			});
			$('[data-js-bureaux-titre]').click(function(){
				var index = $(this).attr('data-js-bureaux-titre');
				index = parseInt( index, 10 );
				console.log('index', index);
				$('[data-js-bureaux-titre]').removeClass('is-active')
					.eq(index).addClass('is-active');
				if ( $(this).closest('.services__content').length == 0 || MQ(-767) ){
					$slider.slick('slickPause');
					$slider.slick('slickGoTo', index);
				}
			});
			$('[data-js-bureaux-titre]').eq(0).addClass('is-active');

			$(el).find('[data-js="slideshow-arrow"]').click(function(){ 
				$slider.slick('slickPause');
			});
			// On before slide change
			$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// console.log(slick);
				// console.log(currentSlide);
				// console.log(nextSlide);
				$(el).find('[data-js="slick-nav-item"]').removeClass('is-active')
					.eq( nextSlide ).addClass('is-active')
				$(el).find('[data-js="slick-nb-item"]').removeClass('is-active')
					.eq( nextSlide ).addClass('is-active')
			});

			$(el).find('[data-js="slick-nav-item"]').first().addClass('is-active');
			$(el).find('[data-js="slick-nb-item"]').first().addClass('is-active');
		// }

		// $(el).find('[data-fancybox]').each(function(i, el){
		// 	$(el).attr('data-fancybox', 'xxx'+(Math.round(Math.random() * 999999)))
		// })

		

		$slider.on('mousedown touchstart', function() {
		    $slider.slick('slickPause');
		});
	});

	$(el).find('[data-js="swiper"]').each(function(i, el) {
		let swiper = null;
		var createSwiper = function() {

			if (swiper) {
				swiper.destroy(true, true);
				swiper = null;
			}

			$(el).addClass('display-not-first');

			if ($(el).find('.swiper-slide').length < 2) {
				$(el).find('.slideshow__arrows ').remove();
				return;
			}
			$(el).addClass('has-slides');

			var initialSlide = 0;
			if ($(el).attr('data-start-index')) {
				initialSlide = parseInt($(el).attr('data-start-index'), 10);
			}

			// Gestion navs personnalisés
			// const navItems = el.querySelectorAll('[data-js="slick-nav-item"]');
			// const nbItems = el.querySelectorAll('[data-js="slick-nb-item"]');
			// const prevArrow = el.querySelector('[data-js="slideshow-arrow"].prev');
			// const nextArrow = el.querySelector('[data-js="slideshow-arrow"].next');

			function qsLocal(root, selector) {
				return [...root.querySelectorAll(selector)]
					.filter(el => el.closest('[data-js="swiper"]') === root);
			}

			const navItems = qsLocal(el, '[data-js="slick-nav-item"]');
			const nbItemsGroups = qsLocal(el, '[data-js="slick-nbs-item"]');
			// const nbItems = qsLocal(el, '[data-js="slick-nb-item"]');
			const prevArrow = qsLocal(el, '[data-js="slideshow-arrow"].prev')[0];
			const nextArrow = qsLocal(el, '[data-js="slideshow-arrow"].next')[0];

			console.log('swiper navItems', navItems);
			console.log('swiper nbItems', nbItemsGroups);
			// console.log('swiper nbItems', nbItems);
			console.log('swiper prevArrow', prevArrow);
			console.log('swiper nextArrow', nextArrow);

			var options = {
				loop: true,
				slidesPerView: 'auto',
				spaceBetween: 0,
				speed: 350,
				grabCursor: true,
				// slideToClickedSlide: true,
				threshold: 10,
				resistanceRatio: 0.5,
				slideToClickedSlide: false,
				autoplay: {
					enabled: false,
					delay: 3000, // tu peux configurer autoplay si besoin
				},
				centeredSlides: true,
				initialSlide: initialSlide,

				navigation: {
					prevEl: prevArrow,
					nextEl: nextArrow
				},

				// LES DEUX PARAMÈTRES CRUCIAUX :
			    watchOverflow: true,       // Détecte le non-débordement et désactive la navigation/drag
			    toggleSlidesClasses: true, // Force la mise à jour des classes CSS des slides si ça déborde pas
 
				// 1. Activation du clavier
				    keyboard: {
				        enabled: true,
				        onlyInViewport: true, // Évite de faire défiler le slider si l'utilisateur est ailleurs sur la page
				    },

				    // 2. Activation du scroll (souris / trackpad)
				 //    mousewheel: {
					//     invert: false,
					//     releaseOnEdges: false,
					//     sensitivity: 5, // Augmente la sensibilité (par défaut c'est 1)
					//     eventsTarget: '.projetspost__infos__mw' // Force Swiper à écouter exactement sur cette cible
					// },

				on: {
					init: function() {
						// Active le premier nav et numéro
						updateNavAndNumber(this.realIndex);
						window.dispatchEvent(new CustomEvent('slides:swiperInit', { detail: this }));

						try {
							const newSlide = swiper.slides[swiper.activeIndex];
							$(window).trigger('slides:swiperBeforeChange', [swiper, null, newSlide]);
						} catch(e){}

					},
					slideChangeTransitionStart: function() {
						try {
							updateNavAndNumber(this.realIndex);

							const swiper = this;
							const realOldIndex = swiper.slides[swiper.previousIndex].dataset.swiperSlideIndex;
							const realNewIndex = swiper.slides[swiper.activeIndex].dataset.swiperSlideIndex;

							if (realOldIndex === undefined || realNewIndex === undefined) return;

							// Récupère les slides originales (pas les clones)
							// const oldSlide = swiper.el.querySelector(`.swiper-slide[data-swiper-slide-index="${realOldIndex}"]:not(.swiper-slide-duplicate)`);
							// const newSlide = swiper.el.querySelector(`.swiper-slide[data-swiper-slide-index="${realNewIndex}"]:not(.swiper-slide-duplicate)`);
							const oldSlide = swiper.el.querySelector(`.swiper-slide-prev`);
							const newSlide = swiper.el.querySelector(`.swiper-slide-active`);

							$(window).trigger('slides:swiperBeforeChange', [swiper, oldSlide, newSlide]);

							window.dispatchEvent(new CustomEvent('slides:swiperChange', { detail: this }));
							
						} catch(error){
							console.error("slideChangeTransitionStart error :", error);
						}
					},
				},
			};

			// Si data-swiper-options existe, on merge les options
			var dataOptions = el.getAttribute('data-swiper-options');
			if (dataOptions) {
				try {
					const cleanOptions = dataOptions.replace(/'/g, '"');
					console.log('cleanOptions', cleanOptions);
					const parsedOptions = JSON.parse(cleanOptions);
					console.log('parsedOptions', parsedOptions);
					options = { ...options, ...parsedOptions };
				} catch (e) {
					console.warn('Erreur dans data-swiper-options:', e);
				}
			}

			if ( $(el).closest('.home__cessions__group__cessions').length
					|| $(el).closest('.rejoindre__offres__group__liste').length
					|| options.hasScrollbar ) {
				// options.loop = false;
				options.scrollbar = {
				      el: el.querySelector('[data-js="slideshow-scrollbar"]'),
				      draggable: true, // tu peux glisser la scrollbar
				      hide: false      // si tu veux qu’elle reste toujours visible
				    };
			}

			if ( $(el).closest('.plans__bloc__group__visuels').length ) { 
				const mobile = false;
				options.effect = mobile ? 'slide' : 'fade';
				// options.allowTouchMove = true;
				options.slidesPerView = mobile ? 'auto' : 1;
				options.fadeEffect = { crossFade: true };
				// options.grabCursor = mobile;
				// options.allowTouchMove = mobile;
			}

			if ( $(el).closest('.showcase__visuels').length ) { 
				options.keyboard = {
					enabled: true,
					onlyInViewport: true, // Recommandé : n'active les flèches que si le slider est visible
				};
			}

			if ( $(el).closest('.about__reviews__group__reviews__right').length && MQ(769) ) {
				return;
			}

			if (options.effect === 'fade') {
                options.simulateTouch = false;
                options.allowTouchMove = false;
            }

			// el.querySelector('.swiper-container').addEventListener('wheel', function(e) {
		 //        e.stopPropagation();
		 //    }, { passive: false });

			swiper = new Swiper(el.querySelector('.swiper-container'), options);

			// if (scrollZone && mySwiper) {

			    // el.addEventListener('wheel', function(e) {
			    // 	// console.log('xxxxxxxxxxx');
			    //     // ON FORCE l'arrêt de la propagation pour isoler l'event
			    //     e.stopPropagation();
			        
			    //     // IMPORTANT : On n'appelle PAS e.preventDefault() pour ne pas bloquer les autres comportements natifs,
			    //     // mais on récupère la direction du scroll (deltaY > 0 = scroll vers le bas)
			    //     if (e.deltaY > 0) {
			    //         // Scroll vers le bas / vers l'avant -> Slide suivant
			    //         swiper.slideNext();
			    //     } else {
			    //         // Scroll vers le haut / vers l'arrière -> Slide précédent
			    //         swiper.slidePrev();
			    //     }
			        
			    // }, { passive: true }); // passive: true permet de fluidifier le comportement
			// }

			function updateNavAndNumber(activeIndex) {
				navItems.forEach((nav, i) => nav.classList.toggle('is-active', i === activeIndex));
				// nbItems.forEach((nb, i) => nb.classList.toggle('is-active', i === activeIndex));
				// const nbItemsGroups = qsLocal(el, '[data-js="slick-nbs-item"]');
				// const nbItems = qsLocal(el, '[data-js="slick-nb-item"]');
				nbItemsGroups.forEach(function(nbs){
					console.log('nbs', nbs);
					var nbItems = nbs.querySelectorAll('[data-js="slick-nb-item"]');
					console.log('nbItems', nbItems);
					nbItems.forEach((nb, i) => nb.classList.toggle('is-active', i === activeIndex));
				})
			}

			navItems.forEach((nav, i) => {
				nav.addEventListener('click', () => {
					swiper.slideToLoop(i); // slideToLoop prend en compte la boucle
				});
			});

			el.swiperInstance = swiper;
		};

		createSwiper();

		$(el).find('')

		if ($(el).closest('.about__reviews__group__reviews__right').length) {
			const breakpoint = window.matchMedia('(max-width: 768px)');
			breakpoint.addEventListener('change', (e) => {
				// small debounce pour éviter double init lors de resize rapide
				clearTimeout(window.__swiperResizeTimeout);
				window.__swiperResizeTimeout = setTimeout(() => {
					// alert('change')
					createSwiper();
				}, 120);
			});
		}
	});


	
	
	$(el).find('[data-js="slideshow-custom"]').each(function(i, el){
		// alert('x')
		$(el).addClass('display-not-first');

		var slick_options = {
			'prevArrow' : $(el).find('[data-js="slideshow-arrow"]').filter('.prev'),
			'nextArrow' : $(el).find('[data-js="slideshow-arrow"]').filter('.next'),
			autoplay: 0,
			// arrows: false,
			fade: true,
			infinite: true,
			autoplaySpeed: 4000,
			// pauseOnHover: true,
			speed: 800,
			// slidesToShow: 6,
			// slidesToScroll: 3,
			swipeToSlide: true,
			mobileFirst: true,
			// variableWidth: true,
			// centerMode: true,
			// responsive: [
			//     {
			//       breakpoint: 8000,
			//       settings: 'unslick'
			//     },
			//     {
			//       breakpoint: 768,
			//       settings: {
			//         slidesToShow: 1,
			//         slidesToScroll: 1
			//       }
			//     }
			//     // You can unslick at a given breakpoint now by adding:
			//     // settings: "unslick"
			//     // instead of a settings object
			//   ]
			// asNavFor: '.imm__slide__titres__items, .imm__slide__txts__items'
			// appendDots: $(el).prev(),
			// appendDots: $(el).parent().find('[data-js="slickdots"]'),
			// dots: true,
			// dotsClass : 'slickslide__navs'
		};
		if ( $(el).closest('.home__services__slide--services').length ){
			slick_options.responsive = [{breakpoint:768, settings: 'unslick'}];
		}
		if ( $(el).find('.map').length > 0 ){
			slick_options.swipeToSlide = false;
		}
		$(el).find('[data-js="slideshow-items"]').on('init', function(event, slick){
			$(window).trigger('slides:init', [slick]);
		});
		$(el).find('[data-js="slideshow-items"]').slick(slick_options);
		// alert( $(el).find('.slideshow__item').length )
		if ( $(el).find('.slideshow__item').length < 2 ){
			$(el).find('.slideshow__navs').hide();
		}

		// On before slide change
		$(el).find('[data-js="slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			console.log(slick);
			console.log(currentSlide);
			console.log(nextSlide);
			// $(el).find('.home__video__txts').removeClass('is-active')
				// .eq( nextSlide ).addClass('is-active')
			if ( $(slick.$slides[nextSlide]).find('.cahier__content__plans__slideshow__legende').length > 0 ){
				console.log('founded');
				var legende = $(slick.$slides[nextSlide]).find('.inner').html();
				console.log('legende', legende);
				var old = $('.cahier__content__plans__tag .inner').html(legende);
				// var n = old.clone();

			}
			$(window).trigger('slides:slickBeforeChange', [slick, currentSlide, nextSlide]);
		});

		$(el).find('[data-js="slideshow-items"]').on('init', function(event, slick){
			$(window).trigger('slides:init', [slick]);
		});

		// $(el).find('.home__video__txts').eq(0).addClass('is-active')
		
		// var options = $(el).attr('data-js-options');
		
		// if ( $(el).attr('data-js-options') == 'slick-with-navs' ) {
			var size = $(el).find('[data-js="slick-nav-item"]').size();
			// custom navs
			$(el).find('[data-js="slick-nav-item"]').click(function(){
				// var index = $(this).index($(el).find('[data-js="slick-nav-item"]'));
				const $items = $(el).find('[data-js="slick-nav-item"]');
				const index = $items.index(this);
				console.log('index', index);
				if ( $(this).closest('.services__content').length == 0 || MQ(-767) ){
					$(el).find('[data-js="slideshow-items"]').slick('slickGoTo', index);
				}
			});
			// On before slide change
			$(el).find('[data-js="slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// console.log(slick);
				// console.log(currentSlide);
				// console.log(nextSlide);
				$(el).find('[data-js="slick-nav-item"]').removeClass('is-active')
					.eq( nextSlide ).addClass('is-active')
				$(el).find('[data-js="slick-nb-item"]').removeClass('is-active')
					.eq( nextSlide ).addClass('is-active')
			});

			$(el).find('[data-js="slick-nav-item"]').first().addClass('is-active');
			$(el).find('[data-js="slick-nb-item"]').first().addClass('is-active');
		// }

		// $(el).find('[data-fancybox]').each(function(i, el){
		// 	$(el).attr('data-fancybox', 'xxx'+(Math.round(Math.random() * 999999)))
		// })
	});

	$(el).find('[data-js="slideshow-partenaires"]').each(function(i, el){
		// alert('x')
		var slick_options = {
			'prevArrow' : $(el).find('[data-js="slideshow-arrow"]').filter('.prev'),
			'nextArrow' : $(el).find('[data-js="slideshow-arrow"]').filter('.next'),
			autoplay: true,
			// arrows: false,
			// fade: true,
			infinite: true,
			autoplaySpeed: 4000,
			pauseOnHover: true,
			speed: 400,
			// slidesToShow: 3,
			slidesToScroll: 1,
			swipeToSlide: true,
			variableWidth: true,
			centerMode: false,
			mobileFirst: true,
			responsive: [
			    {
			      breakpoint: 8000,
			      settings: {
			        slidesToShow: 3,
			        slidesToScroll: 1
			      }
			      // settings: 'unslick'
			    },
			    {
			      breakpoint: 768,
			      settings: {
			        slidesToShow: 1,
			        slidesToScroll: 1
			      }
			    }
			    // You can unslick at a given breakpoint now by adding:
			    // settings: "unslick"
			    // instead of a settings object
			  ]
			// asNavFor: '.imm__slide__titres__items, .imm__slide__txts__items'
			// appendDots: $(el).prev(),
			// appendDots: $(el).parent().find('[data-js="slickdots"]'),
			// dots: true,
			// dotsClass : 'slickslide__navs'
		};
		$(el).find('[data-js="slideshow-items"]').slick(slick_options);
		// alert( $(el).find('.slideshow__item').length )
		if ( $(el).find('.slideshow__item').length < 4 ){
			$(el).find('.slideshow__navs').addClass('only__pho');
			$(el).find('.slideshow__arrows').addClass('only__pho');
		}

		// On before slide change
		// $(el).find('[data-js="home-slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		// 	// console.log(slick);
		// 	// console.log(currentSlide);
		// 	// console.log(nextSlide);
		// 	$(el).find('.home__video__txts').removeClass('is-active')
		// 		.eq( nextSlide ).addClass('is-active')
		// });

		// $(el).find('.home__video__txts').eq(0).addClass('is-active')
		
		// var options = $(el).attr('data-js-options');
		
		// if ( $(el).attr('data-js-options') == 'slick-with-navs' ) {
			var size = $(el).find('[data-js="slick-nav-item"]').size();
			// custom navs
			$(el).find('[data-js="slick-nav-item"]').click(function(){
				var index = $(this).index();
				// console.log('index', index);
				$(el).find('[data-js="slideshow-items"]').slick('slickGoTo', index);
			});
			// On before slide change
			$(el).find('[data-js="slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// console.log(slick);
				// console.log(currentSlide);
				// console.log(nextSlide);
				$(el).find('[data-js="slick-nav-item"]').removeClass('is-active')
					.eq( nextSlide ).addClass('is-active')
			});

			$(el).find('[data-js="slick-nav-item"]').first().addClass('is-active');
		// }

		// $(el).find('[data-fancybox]').each(function(i, el){
		// 	$(el).attr('data-fancybox', 'xxx'+(Math.round(Math.random() * 999999)))
		// })
	});

	$(el).find('[data-js="slideshow-infos-pratiques-menu"]').each(function(i, el){
		// alert('x')
		var slick_options = {
			'prevArrow' : $(el).find('[data-js="slideshow-arrow"]').filter('.prev'),
			'nextArrow' : $(el).find('[data-js="slideshow-arrow"]').filter('.next'),
			autoplay: false,
			// arrows: false,
			// fade: true,
			infinite: false,
			autoplaySpeed: 4000,
			pauseOnHover: true,
			speed: 400,
			// slidesToShow: 3,
			slidesToScroll: 1,
			swipeToSlide: true,
			variableWidth: false,
			centerMode: false,
			responsive: [
			    {
			      breakpoint: 8000,
			      settings: {
			        slidesToShow: 4,
			        slidesToScroll: 1
			      }
			      // settings: 'unslick'
			    },
			    {
			      breakpoint: 768,
			      settings: 'unslick'
			    }
			    // You can unslick at a given breakpoint now by adding:
			    // settings: "unslick"
			    // instead of a settings object
			  ]
			// asNavFor: '.imm__slide__titres__items, .imm__slide__txts__items'
			// appendDots: $(el).prev(),
			// appendDots: $(el).parent().find('[data-js="slickdots"]'),
			// dots: true,
			// dotsClass : 'slickslide__navs'
		};
		$(el).find('[data-js="slideshow-items"]').slick(slick_options);
		// alert( $(el).find('.slideshow__item').length )
		

		// On before slide change
		// $(el).find('[data-js="home-slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		// 	// console.log(slick);
		// 	// console.log(currentSlide);
		// 	// console.log(nextSlide);
		// 	$(el).find('.home__video__txts').removeClass('is-active')
		// 		.eq( nextSlide ).addClass('is-active')
		// });

		// $(el).find('.home__video__txts').eq(0).addClass('is-active')
		
		// var options = $(el).attr('data-js-options');
		
		// if ( $(el).attr('data-js-options') == 'slick-with-navs' ) {
			var size = $(el).find('[data-js="slick-nav-item"]').size();
			// custom navs
			$(el).find('[data-js="slick-nav-item"]').click(function(){
				var index = $(this).index();
				// console.log('index', index);
				$(el).find('[data-js="slideshow-items"]').slick('slickGoTo', index);
			});
			// On before slide change
			$(el).find('[data-js="slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// console.log(slick);
				// console.log(currentSlide);
				// console.log(nextSlide);
				$(el).find('[data-js="slick-nav-item"]').removeClass('is-active')
					.eq( nextSlide ).addClass('is-active')
			});

			$(el).find('[data-js="slick-nav-item"]').first().addClass('is-active');
		// }

		// $(el).find('[data-fancybox]').each(function(i, el){
		// 	$(el).attr('data-fancybox', 'xxx'+(Math.round(Math.random() * 999999)))
		// })
	});

	$(el).find('.blocs__infos__pratiques__content').each(function(i, el){
		// alert('x')
		var slick_options = {
			// 'prevArrow' : $(el).find('[data-js="slideshow-arrow"]').filter('.prev'),
			// 'nextArrow' : $(el).find('[data-js="slideshow-arrow"]').filter('.next'),
			autoplay: false,
			arrows: false,
			// fade: true,
			infinite: false,
			autoplaySpeed: 4000,
			pauseOnHover: true,
			speed: 400,
			// slidesToShow: 3,
			slidesToScroll: 1,
			swipeToSlide: true,
			variableWidth: false,
			centerMode: false,
			adaptiveHeight: true
			// responsive: [
			//     {
			//       breakpoint: 8000,
			//       settings: {
			//         slidesToShow: 3,
			//         slidesToScroll: 1
			//       }
			//       // settings: 'unslick'
			//     },
			//     {
			//       breakpoint: 768,
			//       settings: {
			//         slidesToShow: 1,
			//         slidesToScroll: 1
			//       }
			//     }
			//     // You can unslick at a given breakpoint now by adding:
			//     // settings: "unslick"
			//     // instead of a settings object
			//   ]
			// asNavFor: '.imm__slide__titres__items, .imm__slide__txts__items'
			// appendDots: $(el).prev(),
			// appendDots: $(el).parent().find('[data-js="slickdots"]'),
			// dots: true,
			// dotsClass : 'slickslide__navs'
		};
		$(el).find('.blocs__infos__pratiques__onglets__items').slick(slick_options);
		// alert( $(el).find('.slideshow__item').length )
		// if ( $(el).find('.slideshow__item').length < 4 ){
		// 	$(el).find('.slideshow__navs').addClass('only__pho');
		// 	$(el).find('.slideshow__arrows').addClass('only__pho');
		// }

		// On before slide change
		// $(el).find('[data-js="home-slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		// 	// console.log(slick);
		// 	// console.log(currentSlide);
		// 	// console.log(nextSlide);
		// 	$(el).find('.home__video__txts').removeClass('is-active')
		// 		.eq( nextSlide ).addClass('is-active')
		// });

		// $(el).find('.home__video__txts').eq(0).addClass('is-active')
		
		// var options = $(el).attr('data-js-options');
		
		// if ( $(el).attr('data-js-options') == 'slick-with-navs' ) {
			var size = $(el).find('[data-js="slick-nav-item"]').size();
			// custom navs
			$(el).find('.blocs__infos__pratiques__menu__item').click(function(){
				var index = $(this).index();
				console.log('index', index);
				$(el).find('.blocs__infos__pratiques__menu__item')
					.removeClass('is-current')
					.eq(index).addClass('is-current');

				$(el).find('.blocs__infos__pratiques__onglets__items').slick('slickGoTo', index);
				var title = $(el).find('.blocs__infos__pratiques__menu__item').eq(index).find('.inner').html();
				$(el).find('.blocs__infos__pratiques__menu__items__title__label').html(title);
				$(el).find('.blocs__infos__pratiques__menu__items').removeClass('is-active');
			});
			// On before slide change
			$(el).find('.blocs__infos__pratiques__onglets__items').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// console.log(slick);
				// console.log(currentSlide);
				// console.log(nextSlide);
				// $(el).find('[data-js="slick-nav-item"]').removeClass('is-active')
				// 	.eq( nextSlide ).addClass('is-active')
				$(el).find('.blocs__infos__pratiques__menu__item')
					.removeClass('is-current')
					.eq(nextSlide).addClass('is-current');
				var title = $(el).find('.blocs__infos__pratiques__menu__item').eq(nextSlide).find('.inner').html();
				$(el).find('.blocs__infos__pratiques__menu__items__title__label').html(title);
				$(el).find('.blocs__infos__pratiques__menu__items').removeClass('is-active');
			});

			$(el).find('[data-js="slick-nav-item"]').first().addClass('is-active');

			$(el).find('.blocs__infos__pratiques__menu__items__title').click(function(){
				$(el).find('.blocs__infos__pratiques__menu__items').toggleClass('is-active');
			});
		// }

		// $(el).find('[data-fancybox]').each(function(i, el){
		// 	$(el).attr('data-fancybox', 'xxx'+(Math.round(Math.random() * 999999)))
		// })
	});

	$(el).find('[data-js="slideshow-team"]').each(function(i, el){
		// alert('x')
		var slick_options = {
			'prevArrow' : $(el).find('[data-js="slideshow-arrow"]').filter('.prev'),
			'nextArrow' : $(el).find('[data-js="slideshow-arrow"]').filter('.next'),
			autoplay: false,
			// arrows: false,
			// fade: true,
			infinite: true,
			autoplaySpeed: 4000,
			pauseOnHover: true,
			speed: 400,
			slidesToShow: 5,
			slidesToScroll: 1,
			swipeToSlide: true,
			variableWidth: false,
			centerMode: true,
			responsive: [
			    {
			      breakpoint: 8000,
			      settings: {
			        slidesToShow: 5
			      }
			    },
			    {
			      breakpoint: 768,
			      settings: {
			      	centerMode: false,
			        slidesToShow: 1
			      }
			    }
			    // You can unslick at a given breakpoint now by adding:
			    // settings: "unslick"
			    // instead of a settings object
			  ]
			// asNavFor: '.imm__slide__titres__items, .imm__slide__txts__items'
			// appendDots: $(el).prev(),
			// appendDots: $(el).parent().find('[data-js="slickdots"]'),
			// dots: true,
			// dotsClass : 'slickslide__navs'
		};
		$(el).find('[data-js="slideshow-items"]').slick(slick_options);
		// alert( $(el).find('.slideshow__item').length )
		if ( $(el).find('.slideshow__item').length < 2 ){
			$(el).find('.slideshow__navs').hide();
		}

		// On before slide change
		// $(el).find('[data-js="home-slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		// 	// console.log(slick);
		// 	// console.log(currentSlide);
		// 	// console.log(nextSlide);
		// 	$(el).find('.home__video__txts').removeClass('is-active')
		// 		.eq( nextSlide ).addClass('is-active')
		// });

		// $(el).find('.home__video__txts').eq(0).addClass('is-active')
		
		// var options = $(el).attr('data-js-options');
		
		// if ( $(el).attr('data-js-options') == 'slick-with-navs' ) {
			var size = $(el).find('[data-js="slick-nav-item"]').size();
			// custom navs
			$(el).find('[data-js="slick-nav-item"]').click(function(){
				var index = $(this).index();
				// console.log('index', index);
				$(el).find('[data-js="slideshow-items"]').slick('slickGoTo', index);
			});
			// On before slide change
			$(el).find('[data-js="slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// console.log(slick);
				// console.log(currentSlide);
				// console.log(nextSlide);
				$(el).find('[data-js="slick-nav-item"]').removeClass('is-active')
					.eq( nextSlide ).addClass('is-active')
			});

			$(el).find('[data-js="slick-nav-item"]').first().addClass('is-active');
		// }

		// $(el).find('[data-fancybox]').each(function(i, el){
		// 	$(el).attr('data-fancybox', 'xxx'+(Math.round(Math.random() * 999999)))
		// })
	});

	$(el).find('[data-js="insta-slideshow"]').each(function(i, el){
		var slick_options = {
			'prevArrow' : $(el).find('[data-js="home-slideshow-arrow"]').filter('.prev'),
			'nextArrow' : $(el).find('[data-js="home-slideshow-arrow"]').filter('.next'),
			autoplay: false,
			// arrows: false,
			// fade: true,
			infinite: true,
			autoplaySpeed: 4000,
			pauseOnHover: true,
			speed: 1000,
			slidesToShow: 3,
			slidesToScroll: 3,
			swipeToSlide: true,
			responsive: [
			    {
			      breakpoint: 8000,
			      settings: {
			        slidesToShow: 5,
			        slidesToScroll: 1
			      }
			    },
			    {
			      breakpoint: 768,
			      settings: {
			        slidesToShow: 2,
			        slidesToScroll: 1
			      }
			    }
			    // You can unslick at a given breakpoint now by adding:
			    // settings: "unslick"
			    // instead of a settings object
			  ]
			// asNavFor: '.imm__slide__titres__items, .imm__slide__txts__items'
			// appendDots: $(el).prev(),
			// appendDots: $(el).parent().find('[data-js="slickdots"]'),
			// dots: true,
			// dotsClass : 'slickslide__navs'
		};
		$(el).find('[data-js="slideshow-items"]').slick(slick_options);

		// On before slide change
		$(el).find('[data-js="home-slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			// console.log(slick);
			// console.log(currentSlide);
			// console.log(nextSlide);
			$(el).find('.home__video__txts').removeClass('is-active')
				.eq( nextSlide ).addClass('is-active')
		});

		$(el).find('.home__video__txts').eq(0).addClass('is-active')
		
		var options = $(el).attr('data-js-options');
		
		if ( $(el).attr('data-js-options') == 'slick-with-navs' ) {
			var size = $(el).find('[data-js="slick-nav-item"]').size();
			// custom navs
			$(el).find('[data-js="slick-nav-item"]').click(function(){
				var index = $(this).index();
				// console.log('index', index);
				$(el).find('[data-js="slick-items"]').slick('slickGoTo', index);
			});
			// On before slide change
			$(el).find('[data-js="slick-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// console.log(slick);
				// console.log(currentSlide);
				// console.log(nextSlide);
				$(el).find('[data-js="slick-nav-item"]').removeClass('is-active')
					.eq( nextSlide ).addClass('is-active')
			});

			$(el).find('[data-js="slick-nav-item"]').first().addClass('is-active').css({'opacity': 1});
		}

		// $(el).find('[data-fancybox]').each(function(i, el){
		// 	$(el).attr('data-fancybox', 'xxx'+(Math.round(Math.random() * 999999)))
		// })
	});

	$(el).find('[data-js="home-slideshow"]').each(function(i, el){
		var slick_options = {
			// 'prevArrow' : $(el).find('[data-js="home-slideshow-arrow"]').filter('.prev'),
			// 'nextArrow' : $(el).find('[data-js="home-slideshow-arrow"]').filter('.next'),
			autoplay: true,
			arrows: false,
			fade: true,
			infinite: true,
			autoplaySpeed: 4000,
			pauseOnHover: false,
			speed: 1000
			// asNavFor: '.imm__slide__titres__items, .imm__slide__txts__items'
			// appendDots: $(el).prev(),
			// appendDots: $(el).parent().find('[data-js="slickdots"]'),
			// dots: true,
			// dotsClass : 'slickslide__navs'
		};
		$(el).find('[data-js="home-slideshow-items"]').slick(slick_options);

		// On before slide change
		$(el).find('[data-js="home-slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			// console.log(slick);
			// console.log(currentSlide);
			// console.log(nextSlide);
			$(el).find('.home__video__txts').removeClass('is-active')
				.eq( nextSlide ).addClass('is-active')
		});

		$(el).find('.home__video__txts').eq(0).addClass('is-active')
		
		var options = $(el).attr('data-js-options');
		
		if ( $(el).attr('data-js-options') == 'slick-with-navs' ) {
			var size = $(el).find('[data-js="slick-nav-item"]').size();
			// custom navs
			$(el).find('[data-js="slick-nav-item"]').click(function(){
				var index = $(this).index();
				// console.log('index', index);
				$(el).find('[data-js="slick-items"]').slick('slickGoTo', index);
			});
			// On before slide change
			$(el).find('[data-js="slick-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// console.log(slick);
				// console.log(currentSlide);
				// console.log(nextSlide);
				$(el).find('[data-js="slick-nav-item"]').removeClass('is-active')
					.eq( nextSlide ).addClass('is-active')
			});

			$(el).find('[data-js="slick-nav-item"]').first().addClass('is-active').css({'opacity': 1});
		}

		// $(el).find('[data-fancybox]').each(function(i, el){
		// 	$(el).attr('data-fancybox', 'xxx'+(Math.round(Math.random() * 999999)))
		// })
	});


	$(el).find('[data-js="page-slideshow"]').each(function(i, el){
		var slick_options = {
			'prevArrow' : $(el).find('[data-js="home-slideshow-arrow"]').filter('.prev'),
			'nextArrow' : $(el).find('[data-js="home-slideshow-arrow"]').filter('.next'),
			// autoplay: true,
			arrows: true,
			fade: true,
			infinite: true,
			// autoplaySpeed: 4000,
			pauseOnHover: false,
			speed: 1000
			// asNavFor: '.imm__slide__titres__items, .imm__slide__txts__items'
			// appendDots: $(el).prev(),
			// appendDots: $(el).parent().find('[data-js="slickdots"]'),
			// dots: true,
			// dotsClass : 'slickslide__navs'
		};
		$(el).find('[data-js="page-slideshow-items"]').slick(slick_options);

		// On before slide change
		$(el).find('[data-js="page-slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			// console.log(slick);
			// console.log(currentSlide);
			// console.log(nextSlide);
			$(el).find('.page__video__txts').removeClass('is-active')
				.eq( nextSlide ).addClass('is-active')

			if ( slick.$slides.eq(nextSlide).find('.slideshow__item__video').size() > 0 ){
				var video_wrap = slick.$slides.eq(nextSlide).find('.slideshow__item__video');
				if ( video_wrap.find('[data-video-simple="cta"]').size() ){
					// html 5 video
					$(window).trigger('playhtml5video', video_wrap.find('[data-video-simple="cta"]'));
				}
				if ( video_wrap.find('div[data-action="embedvideoframe"]').size() ){
					// html 5 video
					$(window).trigger('playevfvideo', video_wrap.find('div[data-action="embedvideoframe"]'));
				}
			}

			if ( slick.$slides.eq(currentSlide).find('.slideshow__item__video').size() > 0 ){
				var video_wrap = slick.$slides.eq(currentSlide).find('.slideshow__item__video');
				if ( video_wrap.find('[data-video-simple="cta"]').size() ){
					// html 5 video
					setTimeout(function() {
						$(window).trigger('pausehtml5video', video_wrap.find('[data-video-simple="cta"]'));
					}, 1000);
				}
				if ( video_wrap.find('div[data-action="embedvideoframe"]').size() ){
					// html 5 video
					setTimeout(function() {
						$(window).trigger('pauseevfvideo', video_wrap.find('div[data-action="embedvideoframe"]'));
					}, 1000);
				}
			}
		});

		$(el).find('.page__video__txts').eq(0).addClass('is-active')
		
		var options = $(el).attr('data-js-options');
		// alert('a')
		
		if ( $(el).attr('data-js-options') == 'slick-with-navs' ) {
			// alert('v')
			var size = $(el).find('[data-js="slick-nav-item"]').size();
			// custom navs
			$(el).find('[data-js="slick-nav-item"]').click(function(){
				var index = $(this).index();
				// alert(index)
				// console.log('index', index);
				$(el).find('[data-js="page-slideshow-items"]').slick('slickGoTo', index);
			});
			// On before slide change
			$(el).find('[data-js="page-slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// console.log(slick);
				// console.log(currentSlide);
				// console.log(nextSlide);
				$(el).find('[data-js="slick-nav-item"]').removeClass('is-active')
					.eq( nextSlide ).addClass('is-active')
			});

			$(el).find('[data-js="slick-nav-item"]').first().addClass('is-active').css({'opacity': 1});
		}

		// $(el).find('[data-fancybox]').each(function(i, el){
		// 	$(el).attr('data-fancybox', 'xxx'+(Math.round(Math.random() * 999999)))
		// })
	});

});

$(window).on('site:initPage', function(evt, el){

	$(el).find('[data-js="nbs-slide"]').each(function(i, el){
		var slick_options = {
			'prevArrow' : $(el).find('[data-js="nbs-slide-arrow"]').filter('.prev'),
			'nextArrow' : $(el).find('[data-js="nbs-slide-arrow"]').filter('.next'),
			// autoplay: true,
			// arrows: false,
			fade: false,
			infinite: true,
			// autoplaySpeed: 5000,
			pauseOnHover: false
			// asNavFor: '.imm__slide__titres__items, .imm__slide__txts__items'
			// appendDots: $(el).prev(),
			// appendDots: $(el).parent().find('[data-js="slickdots"]'),
			// dots: true,
			// dotsClass : 'slickslide__navs'
		};
		$(el).find('[data-js="nbs-slide-items"]').slick(slick_options);

		// On before slide change
		// $(el).find('[data-js="nb-slide-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		// 	// console.log(slick);
		// 	// console.log(currentSlide);
		// 	// console.log(nextSlide);
		// 	$(el).find('[data-js="nb-slide-nb"]').removeClass('is-active')
		// 		.eq( nextSlide ).addClass('is-active')
		// });
		
		var options = $(el).attr('data-js-options');
		
		if ( $(el).attr('data-js-options') == 'slick-with-navs' ) {
			var size = $(el).find('[data-js="slick-nav-item"]').size();
			// custom navs
			$(el).find('[data-js="slick-nav-item"]').click(function(){
				var index = $(this).index();
				// console.log('index', index);
				$(el).find('[data-js="slick-items"]').slick('slickGoTo', index);
			});
			// On before slide change
			$(el).find('[data-js="slick-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// console.log(slick);
				// console.log(currentSlide);
				// console.log(nextSlide);
				$(el).find('[data-js="slick-nav-item"]').removeClass('is-active')
					.eq( nextSlide ).addClass('is-active')
			});

			$(el).find('[data-js="slick-nav-item"]').first().addClass('is-active').css({'opacity': 1});
		}

		// $(el).find('[data-fancybox]').each(function(i, el){
		// 	$(el).attr('data-fancybox', 'xxx'+(Math.round(Math.random() * 999999)))
		// })
	});

});


$(window).on('site:initPage', function(evt, p){

	$(p).find('[data-js="people-slide"]').each(function(i, el){
		
		$(el).find('[data-js="people-slide-items"]').lightSlider({
			'itemsSelector' : '.about__equipe__blocs__item',
			// 'arrowsItem' : $( el ).find( '.bloc__slideshow__arrow' ).get(),
			// 'arrowLeftClass' : 'bloc__slideshow__arrow--left',
			// 'autoPlay' : true,
			'autoPlay' : false,
			'stopOnHover' : false,
			'onshowitem': bloc_slide_change,
			// 'autoPlayDelay' : 8000,
			// 'navsItem': $(el).find('.team__slide__nav'),
			arrowsItem: $(el).find('[data-js="people-slide-arrow"]'),
			arrowLeftClass: 'prev'
		});

		// $(el).find('.about__equipe__blocs__item').first().addClass('is-active').css({'opacity': 1});
		// $(el).find('[data-js="slick-nav-item"]').first().addClass('is-active');
		var currentIndex = 0;
		var els = $(el).find('.about__equipe__blocs__item');
		gsap.set( els, {
			opacity: 0,
			zIndex: 2
		} );
		gsap.set( els[0], {
			opacity: 1,
			zIndex: 5
		} );
		gsap.set( els[1], {
			opacity: 1,
			rotation: 20,
			zIndex: 4,
			scale: 0.9
			// blur: 8
		} );
		$(el).find('.about__equipe__blocs__name__item').eq(0).addClass('is-active');
	});

});

$(window).on('site:initPage', function(evt, el){

	$(el).find('[data-js="history-slideshow"]').each(function(i, el){
		var slick_options = {
			'prevArrow' : $(el).find('[data-js="history-slideshow-arrow"]').filter('.prev'),
			'nextArrow' : $(el).find('[data-js="history-slideshow-arrow"]').filter('.next'),
			// autoplay: true,
			// arrows: false,
			// fade: true,
			infinite: true,
			// autoplaySpeed: 5000,
			pauseOnHover: false,
			vertical: true,
			verticalSwiping: true
			// asNavFor: '.imm__slide__titres__items, .imm__slide__txts__items'
			// appendDots: $(el).prev(),
			// appendDots: $(el).parent().find('[data-js="slickdots"]'),
			// dots: true,
			// dotsClass : 'slickslide__navs'
		};
		$(el).find('[data-js="history-slideshow-items"]').slick(slick_options);

		// On before slide change
		// $(el).find('[data-js="history-slideshow-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		// 	// console.log(slick);
		// 	// console.log(currentSlide);
		// 	// console.log(nextSlide);
		// 	$(el).find('[data-js="history-slideshow-nb"]').removeClass('is-active')
		// 		.eq( nextSlide ).addClass('is-active')
		// });
		
		var options = $(el).attr('data-js-options');
		
		if ( $(el).attr('data-js-options') == 'slick-with-navs' ) {
			var size = $(el).find('[data-js="slick-nav-item"]').size();
			// custom navs
			$(el).find('[data-js="slick-nav-item"]').click(function(){
				var index = $(this).index();
				// console.log('index', index);
				$(el).find('[data-js="slick-items"]').slick('slickGoTo', index);
			});
			// On before slide change
			$(el).find('[data-js="slick-items"]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// console.log(slick);
				// console.log(currentSlide);
				// console.log(nextSlide);
				$(el).find('[data-js="slick-nav-item"]').removeClass('is-active')
					.eq( nextSlide ).addClass('is-active')
			});

			$(el).find('[data-js="slick-nav-item"]').first().addClass('is-active').css({'opacity': 1});
		}

		// $(el).find('[data-fancybox]').each(function(i, el){
		// 	$(el).attr('data-fancybox', 'xxx'+(Math.round(Math.random() * 999999)))
		// })
	});

});

